import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FaqAccordion from "../components/FaqAccordion";
import { useLanguage } from "../i18n/LanguageProvider";

export default function FaqPage({ showBackButton = false, onBack = null }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  const handleBack = () => {
    if (typeof onBack === "function") {
      onBack();
      return;
    }

    if (location.state?.from === "landing") {
      navigate("/landing");
      return;
    }

    navigate("/");
  };

  return (
    <div
      style={{
        width: "92%",
        margin: "0 auto",
        padding: "calc(18px + var(--vq-safe-area-top)) calc(6px + var(--vq-safe-area-right)) calc(28px + var(--vq-safe-area-bottom)) calc(6px + var(--vq-safe-area-left))",
        color: "white",
        boxSizing: "border-box",
      }}
    >
      {showBackButton && (
        <button
          onClick={handleBack}
          style={{
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.18)",
            color: "#fff",
            padding: "10px 16px",
            borderRadius: "999px",
            cursor: "pointer",
            marginBottom: "22px",
            fontSize: "15px",
            fontWeight: 800,
          }}
        >
          ← {t("common.back")}
        </button>
      )}

      <FaqAccordion />
    </div>
  );
}
